import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { myroutes } from "../../../routes/webroute";
import Swal from "sweetalert2";
import { logoutRequest } from "../../auth/logout";
import { resetAuthData } from "../../../app/providers/authSlice";

export default function SideBar() {
  const auth = useSelector((state) => state.auth);
  const profils = useSelector((state) => state.auth.profil);

  const hasAccessToSensitiveInfo = profils.includes("USER");
  const hasAccessToSensitiveInfoActeur = profils.includes("AJ");

  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <React.Fragment>
      {/* ======= Sidebar ======= */}
      <aside id="sidebar" className="sidebar" style={{ textTransform: "" }}>
        <ul className="sidebar-nav" id="sidebar-nav">
          <li className="nav-item">
            <Link
              className={`nav-link ${currentPath === myroutes.dashboard ? "active" : ""
                }`}
              to={
                hasAccessToSensitiveInfo
                  ? myroutes.dashboard_newuser
                  : myroutes.dashboard_acteur
              }
            >
              <i className="bi bi-speedometer"></i>
              <span>Tableau de bord</span>
            </Link>
          </li>

          {/* End Dashboard Nav */}

          {hasAccessToSensitiveInfoActeur && (
            <>
              <li className="nav-item">
                <Link
                  className="nav-link collapsed"
                  data-bs-target="#dossiers-nav"
                  data-bs-toggle="collapse"
                >
                  <i className="bi bi-journal-text"></i>
                  <span>Dossiers</span>
                  <i className="bi bi-chevron-down ms-auto"></i>
                </Link>
                <ul
                  id="dossiers-nav"
                  className="nav-content collapse "
                  data-bs-parent="#sidebar-nav"
                >

                  <li>
                    <Link to={myroutes.dossiersacteurs_index} className={`${currentPath == myroutes.dossiersacteurs_index && "active"}`}>
                      <i className="bi bi-circle"></i>
                      <span>Liste des dossiers</span>
                    </Link>
                  </li>
                  <li>
                    <Link to={myroutes.dossiersacteurs_creer} className={`${currentPath == myroutes.dossiersacteurs_creer && "active"}`}>
                      <i className="bi bi-circle"></i>
                      <span>Enrôler un dossier</span>
                    </Link>
                  </li>

                </ul>
              </li>

              <li className="nav-item">
                <Link
                  to={myroutes.depot_conclusions_acteur}
                  className={`nav-link ${currentPath === myroutes.depot_conclusions_acteur ? "" : "collapsed"}`}
                >
                  <i className="bi bi-file-earmark-arrow-up"></i>
                  <span>Dépôt de conclusions</span>
                </Link>
              </li>
          
              

              {/** Demandes de copie ou grosse */}
              <li className="nav-item">
                <Link
                  className="nav-link collapsed"
                  data-bs-target="#copie-grosse-nav"
                  data-bs-toggle="collapse"
                >
                  <i className="bi bi-envelope-paper"></i>
                  <span>Demandes de copie ou grosse</span>
                  <i className="bi bi-chevron-down ms-auto"></i>
                </Link>
                <ul
                  id="copie-grosse-nav"
                  className="nav-content collapse "
                  data-bs-parent="#sidebar-nav"
                >

                  <li>
                    <Link to={myroutes.demande_arret_acteur_index} className={`${currentPath == myroutes.demande_arret_acteur_index && "active"}`}>
                      <i className="bi bi-circle"></i>
                      <span>Liste des demandes</span>
                    </Link>
                  </li>
                  <li>
                    <Link to={myroutes.demande_arret} className={`${currentPath == myroutes.demande_arret && "active"}`} target="_blank">
                      <i className="bi bi-circle"></i>
                      <span>Faire une demande</span>
                    </Link>
                  </li>

                </ul>
              </li>

              {/** Requêtes à fin d'ordonnance */}
              <li className="nav-item">
                <Link
                  className="nav-link collapsed"
                  data-bs-target="#requetes-nav"
                  data-bs-toggle="collapse"
                >
                   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24">
                    <path d="M12.9985 2L12.9979 3.278L17.9985 4.94591L21.631 3.73509L22.2634 5.63246L19.2319 6.643L22.3272 15.1549C21.2353 16.2921 19.6996 17 17.9985 17C16.2975 17 14.7618 16.2921 13.6699 15.1549L16.7639 6.643L12.9979 5.387V19H16.9985V21H6.99854V19H10.9979V5.387L7.23192 6.643L10.3272 15.1549C9.23528 16.2921 7.69957 17 5.99854 17C4.2975 17 2.76179 16.2921 1.66992 15.1549L4.76392 6.643L1.73363 5.63246L2.36608 3.73509L5.99854 4.94591L10.9979 3.278L10.9985 2H12.9985ZM17.9985 9.10267L16.5809 13H19.4159L17.9985 9.10267ZM5.99854 9.10267L4.58092 13H7.41592L5.99854 9.10267Z"></path>
                  </svg>&nbsp;
                  <span>Requêtes à fin d'ordonnance</span>
                  <i className="bi bi-chevron-down ms-auto"></i>
                </Link>
                <ul
                  id="requetes-nav"
                  className="nav-content collapse "
                  data-bs-parent="#sidebar-nav"
                >

                  <li>
                    <Link to={myroutes.dossiersacteurs_mes_requetes} className={`${currentPath == myroutes.dossiersacteurs_mes_requetes && "active"}`}>
                      <i className="bi bi-circle"></i>
                      <span>Liste des Requêtes</span>
                    </Link>
                  </li>
                  <li>
                    <Link to={myroutes.dossiersacteurs_add_requete} className={`${currentPath == myroutes.dossiersacteurs_add_requete && "active"}`}>
                      <i className="bi bi-circle"></i>
                      <span>Introduire une requête</span>
                    </Link>
                  </li>
                </ul>
              </li>

              {/**Attestation d'instance */}
              <li className="nav-item">
                <Link
                  className="nav-link collapsed"
                  data-bs-target="#attestations-nav"
                  data-bs-toggle="collapse"
                >
                   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                    <path d="M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM15 11H16V16H8V11H9V10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10V11ZM13 11V10C13 9.44772 12.5523 9 12 9C11.4477 9 11 9.44772 11 10V11H13Z"></path>
                  </svg>&nbsp;
                  <span>Demandes d'attestation d'instance</span>
                  <i className="bi bi-chevron-down ms-auto"></i>
                </Link>
                <ul
                  id="attestations-nav"
                  className="nav-content collapse "
                  data-bs-parent="#sidebar-nav"
                >

                  <li>
                    <Link to={myroutes.dossiersacteurs_mes_attestations} className={`${currentPath == myroutes.dossiersacteurs_mes_attestations && "active"}`}>
                      <i className="bi bi-circle"></i>
                      <span>Liste des demandes</span>
                    </Link>
                  </li>
                  <li>
                    <Link to={myroutes.dossiersacteurs_add_attestation} className={`${currentPath == myroutes.dossiersacteurs_add_attestation && "active"}`}>
                      <i className="bi bi-circle"></i>
                      <span>Faire une demande</span>
                    </Link>
                  </li>
                </ul>
              </li>              
             
              {/**Attestation de radiation de role */}
              <li className="nav-item">
                <Link
                  className="nav-link collapsed"
                  data-bs-target="#radiations-nav"
                  data-bs-toggle="collapse"
                >
                   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="32" height="32"><path d="M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM11 15H13V17H11V15ZM11 7H13V13H11V7Z"></path></svg>
                   &nbsp;
                  <span>Demandes d'attestation de radiation de rôle</span>
                  <i className="bi bi-chevron-down ms-auto"></i>
                </Link>
                <ul
                  id="radiations-nav"
                  className="nav-content collapse "
                  data-bs-parent="#sidebar-nav"
                >

                  <li>
                    <Link to={myroutes.dossiersacteurs_mes_attestations_radiations} className={`${currentPath == myroutes.dossiersacteurs_mes_attestations_radiations && "active"}`}>
                      <i className="bi bi-circle"></i>
                      <span>Liste des demandes</span>
                    </Link>
                  </li>
                  <li>
                    <Link to={myroutes.dossiersacteurs_add_attestation_radiations} className={`${currentPath == myroutes.dossiersacteurs_add_attestation_radiations && "active"}`}>
                      <i className="bi bi-circle"></i>
                      <span>Faire une demande</span>
                    </Link>
                  </li>
                </ul>
              </li> 

              {/**Attestation de pourvoi */}
              <li className="nav-item">
                <Link
                  className="nav-link collapsed"
                  data-bs-target="#pourvoi-nav"
                  data-bs-toggle="collapse"
                >
                   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="32" height="32"><path d="M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM11 15H13V17H11V15ZM11 7H13V13H11V7Z"></path></svg>
                   &nbsp;
                  <span>Demandes d'attestation de pourvoi</span>
                  <i className="bi bi-chevron-down ms-auto"></i>
                </Link>
                <ul
                  id="pourvoi-nav"
                  className="nav-content collapse "
                  data-bs-parent="#sidebar-nav"
                >

                  <li>
                    <Link to={myroutes.dossiersacteurs_mes_attestations_pourvoi.replace(':type', 'pourvoi').replace(':is_pourvoi', 'true')} 
                    className={`${currentPath == myroutes.dossiersacteurs_mes_attestations_pourvoi.replace(':type', 'pourvoi').replace(':is_pourvoi', 'true') && "active"}`}>
                      <i className="bi bi-circle"></i>
                      <span>Liste des attestations de pourvoi</span>
                    </Link>
                  </li>

                   <li>
                    <Link to={myroutes.dossiersacteurs_mes_attestations_pourvoi.replace(':type', 'pourvoi').replace(':is_pourvoi', 'false')} 
                    className={`${currentPath == myroutes.dossiersacteurs_mes_attestations_pourvoi.replace(':type', 'pourvoi').replace(':is_pourvoi', 'false') && "active"}`}>
                      <i className="bi bi-circle"></i>
                      <span>Liste des attestations de non pourvoi</span>
                    </Link>
                  </li>
                  <li>
                    <Link to={myroutes.dossiersacteurs_add_attestation_pourvoi.replace(':type', 'pourvoi').replace(':is_pourvoi', 'true')} 
                    className={`${currentPath == myroutes.dossiersacteurs_add_attestation_pourvoi.replace(':type', 'pourvoi').replace(':is_pourvoi', 'true') && "active"}`}>
                      <i className="bi bi-circle"></i>
                      <span>Faire une demande d'attestation de pourvoi</span>
                    </Link>
                  </li>
                  <li>
                    <Link to={myroutes.dossiersacteurs_add_attestation_pourvoi.replace(':type', 'pourvoi').replace(':is_pourvoi', 'false')} 
                    className={`${currentPath == myroutes.dossiersacteurs_add_attestation_pourvoi.replace(':type', 'pourvoi').replace(':is_pourvoi', 'false') && "active"}`}>
                      <i className="bi bi-circle"></i>
                      <span>Faire une demande d'attestation de non pourvoi</span>
                    </Link>
                  </li>
                </ul>
              </li>

              {/** Légalisation de pièces */}
              <li className="nav-item">
                <Link
                  className="nav-link collapsed"
                  data-bs-target="#legalisations-nav"
                  data-bs-toggle="collapse"
                >
                   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                    <path d="M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM15 11H16V16H8V11H9V10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10V11ZM13 11V10C13 9.44772 12.5523 9 12 9C11.4477 9 11 9.44772 11 10V11H13Z"></path>
                  </svg>&nbsp;
                  <span>Demandes de légalisation de pièces</span>
                  <i className="bi bi-chevron-down ms-auto"></i>
                </Link>
                <ul
                  id="legalisations-nav"
                  className="nav-content collapse "
                  data-bs-parent="#sidebar-nav"
                >

                  <li>
                    <Link to={myroutes.dossiersacteurs_mes_legalisations} className={`${currentPath == myroutes.dossiersacteurs_mes_legalisations && "active"}`}>
                      <i className="bi bi-circle"></i>
                      <span>Liste des légalisation de pièces</span>
                    </Link>
                  </li>
                  <li>
                    <Link to={myroutes.dossiersacteurs_add_legalisation} className={`${currentPath == myroutes.dossiersacteurs_add_legalisation && "active"}`}>
                      <i className="bi bi-circle"></i>
                      <span>Faire une demande</span>
                    </Link>
                  </li>
                </ul>
              </li>
            </>
          )}

          {profils.includes("AGEC") || profils.includes("APDT") ? (
            <li className="nav-item">
              <Link
                className="nav-link collapsed"
                data-bs-target="#dossiers-nav"
                data-bs-toggle="collapse"
              >
                <i className="bi bi-journal-text"></i>
                <span>Dossiers</span>
                <i className="bi bi-chevron-down ms-auto"></i>
              </Link>
              <ul
                id="dossiers-nav"
                className="nav-content collapse "
                data-bs-parent="#sidebar-nav"
              >
                <li>
                  <Link to={myroutes.dossiersacteurs_index}>
                    <i className="bi bi-circle"></i>
                    <span>Mes dossiers</span>
                  </Link>
                </li>
              </ul>
            </li>
          ) : null}

          {/***
           * {!profils.includes("USER") && (
            <li className="nav-item">
              <Link
                className="nav-link collapsed" to={myroutes.demande_arret_create}>
                <i className="bi bi-envelope-paper"></i>
                <span>Demande de copie ou grosse</span>
              </Link>
            </li>
          )}
           */}

          {/* End Forms Nav */}
        </ul>
      </aside>
      {/* End Sidebar*/}
    </React.Fragment>
  );
}
